<script>
	import { fly } from 'svelte/transition';
	import { cubicOut } from 'svelte/easing';
	import { onMount } from 'svelte';
	export let formId;
	export let label;
	export let options;
	export let value = '';
	export let required = false;
	export let invalid = true;
	export let disabled = false;
	export let focused = false;

	const errorTransition = { y: -5, duration: 50, easing: cubicOut, delay: 0 };
	let validate = () => {
		//	console.log(value, focused, 'valudate');
		if (required && value.length <= 0) {
			invalid = 'please choose an option';
			return;
		}
		invalid = false;
	};
	$: value, validate();
	onMount(() => {
		validate();
	});
</script>

<div class="formItem">
	<label class="form-label" class:inputInvalid={invalid && focused} for={formId}>{label}</label>

	<select
		class:inputInvalid={invalid && focused}
		class="select-input"
		name={formId}
		id={formId}
		{required}
		bind:value
		{disabled}
		on:focus={() => {
			focused = true;
		}}
	>
		<option value="" disabled>--Please choose an option--</option>
		{#each options as option}
			<option value={option.val}>{option.label}</option>
		{/each}
	</select>
	<div class="form-error-row">
		{#if invalid && focused}
			<p class="form-error" transition:fly={errorTransition}>{invalid}</p>
		{/if}
	</div>
</div>

<style>
	.formItem:not(:last-child) {
		margin-right: 1em;
	}
	.formItem {
		width: 100%;
	}
	select {
		width: 100%;
	}
</style>
